import { combineReducers } from "redux";
import attendanceConfigSlice from "../sagas/Attendance/attendanceConfigSlice";
import authSlice from '../sagas/auth/authSlice'
import checklistConfigSlice from "../sagas/ChecklistPlanner/checklistConfigSlice";
import dashboardConfigSlice from "../sagas/DashboardConfig/dashboardConfigSlice";
import employeeHelpDeskConfigSlice from "../sagas/Employee Helpdesk/employeeHelpDeskConfigSlice";
import leaveConfigSlice from "../sagas/LeaveConfig/leaveConfigSlice";
import myCertificateConfigSlice from "../sagas/MyCertificate/myCertificateConfigSlice";
import spotRewardsConfigSlice from "../sagas/MyCertificate/SpotRewards/spotRewardsConfigSlice";
import spotRewardConfigSlice from "../sagas/SpotRewardConfig/spotRewardConfigSlice";

export const rootReducer = combineReducers({
    authConfig: authSlice,
    dashboardConfig: dashboardConfigSlice,
    leaveConfig: leaveConfigSlice,
    spotRewardConfig: spotRewardConfigSlice,
    attendanceConfig: attendanceConfigSlice,
    certificateConfig: myCertificateConfigSlice,
    spotRewards: spotRewardsConfigSlice,
    employeeHelpdesk: employeeHelpDeskConfigSlice,
    checklist: checklistConfigSlice,
})